const CARD_FIELDS = [
  'id',
  'product_id',
  'sku',
  'url',
  'image',
  'mobile_image',
  'second_image',
  'display_name',
  'unit',
  'main_price',
  'hc_standard_price',
  'hc_recommended_price',
  'discount',
  'labels',
  'anotherColors',
  'restparti_qty',
  'restparti_unit_block',
  'Lager Status_attr',
  'admin',
]

function slimCardProduct(product) {
  if (!product || typeof product !== 'object') {
    return product
  }

  const slim = {}
  for (const key of CARD_FIELDS) {
    if (product[key] !== undefined) {
      slim[key] = product[key]
    }
  }

  if (Array.isArray(slim.anotherColors)) {
    slim.anotherColors = slim.anotherColors.map((color) => ({
      image: color?.image,
      url: color?.url,
      ...(color?.id != null ? { id: color.id } : {}),
    }))
  }

  return slim
}

function slimPlugins(plugins) {
  if (!Array.isArray(plugins)) {
    return
  }

  for (const plugin of plugins) {
    if (plugin?.name === 'CategoryDescription' && plugin.data) {
      delete plugin.data.bottom_description
    }

    if (plugin?.name === 'ProductsGrid' && Array.isArray(plugin.data?.products_data?.products)) {
      plugin.data.products_data.products = plugin.data.products_data.products.map(slimCardProduct)
    }

    if (plugin?.name === 'MiniProductsGrid' && Array.isArray(plugin.data?.products)) {
      plugin.data.products = plugin.data.products.map(slimCardProduct)
    }
  }
}

export function slimPagePayload(payload) {
  const groups = payload?.data?.grouped_plugins
  if (!groups || typeof groups !== 'object') {
    return payload
  }

  for (const plugins of Object.values(groups)) {
    slimPlugins(plugins)
  }

  return payload
}
